<template></template>

<script>
import { Items } from "@pdfking/tfunc"

import deserialize_filelist from "../files/make/deserialize_filelist"
import new_file_from_virtualfile from "../files/make/new_file_from_virtualfile"

export default {
  props: ["filelist"],
  computed: {
    filenames() {
      return Items(deserialize_filelist(this.filelist)).map(([path, file]) =>
        new_file_from_virtualfile({ path, file })
      )
    },
  },
}
</script>
